import { render, staticRenderFns } from "./KanaInputForm.vue?vue&type=template&id=1cae7b0a&scoped=true&"
import script from "./KanaInputForm.vue?vue&type=script&lang=js&"
export * from "./KanaInputForm.vue?vue&type=script&lang=js&"
import style0 from "./KanaInputForm.vue?vue&type=style&index=0&id=1cae7b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cae7b0a",
  null
  
)

export default component.exports